import { useContext, useEffect, useState } from "react";
import PageLoading from "../PageLoading";
import { SimpleStatistics } from "../../library/CosmeWidgetAPIClient";
import { CWClientContext } from "../../App";
import NumberBoard from "./premitive/NumberBoard";
import { makeStyles } from "@fluentui/react-components";



type QueueBoardProp = {
    className?: string,
}

const QueueBoard = (prop: QueueBoardProp) => {
    const [queueStat, setQueueStat] = useState<SimpleStatistics[]>();
    const cwClient = useContext(CWClientContext);

    useEffect(() => {
        (async () => {
            let as = await cwClient.getQueueCounts();
            setQueueStat(as);
        })();
    }, []);

    const jobNames: { [key: string]: string } = {};
    jobNames["browse"] = "ページ保存";
    jobNames["extract"] = "AI抽出";

    const QueueBoard = () => {
        if (queueStat === undefined) {
            return <PageLoading
                message='キュー情報を取得中です'
            />;
        } else {
            return (
                <>
                    {queueStat?.map((qs: SimpleStatistics) => {
                        return (
                            <NumberBoard
                                title={jobNames[qs.legend] + "待ち件数"}
                                value={qs.count}
                            />
                        );
                    })
                    }
                </>
            )
        }
    }
    return (
        <QueueBoard />
    );
}

export default QueueBoard;